import { useEffect, useRef, useState } from 'react';
import { Warning, X } from '@phosphor-icons/react';
import { devApi } from './devApi';

/**
 * 品名を打っている最中に「似た資産があります」を出すだけの案内。
 * 検索は 必要部品／資産登録 と同じ master-search（正規化突き合わせ済み）を使う。
 * 自動選択も自動統合もしない。閉じたらその入力のあいだは出さない。
 */
export const SimilarAssetHint = ({ name, testid = 'similar-asset-hint' }) => {
  const [hits, setHits] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    const q = (name || '').trim();
    if (q.length < 2) { setHits([]); return undefined; }
    timer.current = setTimeout(async () => {
      try {
        const rows = await devApi.masterSearch(q);
        setHits((rows || []).filter((r) => r.source === 'eng').slice(0, 3));
      } catch (_e) { setHits([]); }
    }, 300);
    return () => { if (timer.current) clearTimeout(timer.current); };
  }, [name]);

  useEffect(() => { setDismissed(false); }, [name]);

  if (dismissed || hits.length === 0) return null;
  return (
    <div className="mt-1 rounded-md border border-amber-300 bg-amber-50 px-3 py-2" data-testid={testid}>
      <div className="flex items-start justify-between gap-2">
        <p className="flex items-center gap-1 text-xs font-semibold text-amber-900">
          <Warning size={13} /> 似た資産があります（{hits.length}件）
        </p>
        <button type="button" onClick={() => setDismissed(true)}
          className="text-amber-800 hover:text-amber-950" data-testid={`${testid}-dismiss`}
          aria-label="閉じる">
          <X size={13} />
        </button>
      </div>
      <ul className="mt-0.5 space-y-0.5">
        {hits.map((h) => (
          <li key={h.id} className="text-xs text-amber-900" data-testid={`${testid}-row-${h.id}`}>
            {h.name}
            {h.sku ? <span className="ml-1 font-mono text-amber-800">{h.sku}</span> : null}
            {h.on_hand != null ? <span className="ml-1 text-amber-800">在庫 {h.on_hand}</span> : null}
          </li>
        ))}
      </ul>
      <p className="mt-0.5 text-[11px] text-amber-800">
        同じものなら、新しく登録せず既存の資産を使ってください。自動では選びません。
      </p>
    </div>
  );
};
